import React, { Fragment, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { File } from 'react-feather';
import { IEvaluation } from './types';
import {
    Card,
    CardContent,
    CardHeader,
    Divider,
    makeStyles,
    Box,
    Button,
    Theme,
} from '@material-ui/core';
import clsx from 'clsx';
import { isEvaluationComplete } from '../utils';
import { Modal } from './Modal';
import { useSnackbar } from 'notistack';
import { TSign } from 'src/interfaces/evaluation';
import { SHOWROOM_LEAD_TYPE } from 'src/constants/lead/leadTypes';

const useStyles = makeStyles((theme: Theme) => ({
    button: { height: 60 },
    incomplete: {
        color: '#FFF',
        backgroundColor: theme.palette.success.main,
        '&:hover': {
            backgroundColor: theme.palette.success.dark,
        },
    },
}));

export const Evaluation = ({ evaluation, lead, ...props }: IEvaluation) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();

    let signs: TSign[] = [];
    if (evaluation?.signs) signs = evaluation.signs;

    const isComplete = isEvaluationComplete(signs);

    const [open, setOpen] = useState<boolean>(false);

    const handleOpen = () => {
        if (lead?.agent) setOpen(true);
        else {
            enqueueSnackbar(t('SnackBar.NoAgent'), {
                variant: 'error',
            });
        }
    };

    useEffect(() => {
        if (lead?.type === SHOWROOM_LEAD_TYPE && !isComplete) {
            setOpen(true);
        }
    }, [lead]);

    return (
        <Fragment>
            <Modal
                open={open}
                setOpen={setOpen}
                maxWidth={'sm'}
                isComplete={isComplete}
            />
            <Card {...props}>
                <CardHeader title={t('Leads.Evaluation')} />
                <Divider />
                <CardContent>
                    <Box display="flex" flexDirection="column" gridGap={15}>
                        <Button
                            className={clsx({
                                [classes.button]: true,
                                [classes.incomplete]: !isComplete,
                            })}
                            startIcon={<File />}
                            onClick={handleOpen}
                            variant="contained"
                            color="primary"
                            size="large"
                            fullWidth
                        >
                            {isComplete
                                ? t('evaluation.complete')
                                : t('evaluation.incomplete')}
                        </Button>
                    </Box>
                </CardContent>
            </Card>
        </Fragment>
    );
};
